/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $win = jQuery(window),
		$body = jQuery('body'),
		$main = jQuery('.main');


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery(window).on('load', function() {

		if( $win.width() > 480) {
			jQuery('.word').lettering();
		}
		jQuery('#ae-cform-input-reg-email-1').attr('placeholder', 'Email');

		jQuery('.top-bar .menu-bars').on('click', function() {
			jQuery(this).find('.fas').toggleClass('fa-times');
		});
		jQuery('.js-off-canvas-overlay').on('click', function() {
			jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
		});

		jQuery('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			// var $target = jQuery(this).attr('href');

			// jQuery('html, body').animate({
			// 	scrollTop: jQuery($target).offset().top
			// }, 800);

			// if ( jQuery(this).parents('.off-canvas') ) {
			// 	jQuery('.js-off-canvas-overlay').trigger('click');
			// }

			jQuery('.ae-cform-modal-display-cta').trigger('click');
		});
		jQuery('.ae-cform-item-submit-button').append('<div class="marquee" aria-hidden="true"><div class="marquee__inner"><span>Submit</span><span>Submit</span><span>Submit</span><span>Submit</span><span>Submit</span><span>Submit</span><span>Submit</span><span>Submit</span></div></div>');
		

		if( $main.hasClass('main-lyrics') ) {
			$select_first = jQuery('.release-select-item').first().text();
			
			console.log($select_first);

			jQuery('.release-selected').append($select_first);

			jQuery('.release-select-item').on('click', function() {
				var $ids = jQuery(this).index(),
					album = jQuery(this).text();

				jQuery('.release-selected').empty().append(album);
				jQuery('.release-select').removeClass('show');
				jQuery('.links a').removeClass('active');
				jQuery(this).addClass('active');
				
				// animate
				jQuery('.lyrics').hide();
				jQuery('.lyrics:eq(' + $ids + ')').show();
				return false;
			});

			jQuery('.release-selected').on('click', function(){
				jQuery('.release-select').addClass('show');
			});

			jQuery('.lyrics').on('click', function(){
				jQuery('.release-select').removeClass('show');
			});
		}

		if( $body.hasClass('home') ) {
			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list'),
				$releases = jQuery('.js-release-list'),
				$menu = jQuery('#main-nav li a');

			setTimeout(function(){
				jQuery('.ae-cform-modal-display-cta').trigger('click');
			}, 2000);

			// $menu.on('click', function(e) {
			// 	var $title = jQuery(this).attr('title').toLowerCase();

			// 	if($title) {
			// 		e.preventDefault();

			// 		jQuery('.menu-primary li').removeClass('active');
			// 		jQuery(this).parent().addClass('active');

			// 		jQuery('html, body').animate({
			// 			scrollTop: jQuery('.section-'+$title).offset().top - 64
			// 		}, 800);
			// 	}
			// });
			
			$banner.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

			jQuery('.section-banner').addClass('init');

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });
			// jQuery('.js-news-list').slick({
			// 	slidesToShow: 3,
			// 	slidesToScroll: 3,
			// 	responsive: [
			// 	  {
			// 		breakpoint: 480,
			// 		settings: {
			// 		  slidesToShow: 1,
			// 		  slidesToScroll: 1
			// 		}
			// 	  }
			// 	]
			// });

			$releases.on('init', function(event, slick){
				var currentSlide = jQuery(this).find('.slick-slide.slick-current');

				if(currentSlide) {
					// textAnime();
				}
			});

			$releases.slick({
				asNavFor: '.album-cover-list'
			});

			jQuery('.album-cover-list').slick({
				arrows: false,
				dots: false,
				fade: true,
				cssEase: 'linear',
				asNavFor: '.js-release-list',
				focusOnSelect: true
			});

            $releases.on('afterChange', function(event, slick, currentSlide){
              $releases.addClass('slided');
			  svg();
				textAnime();
            });

			function textAnime() {
				anime({
					targets: '.slick-current .word-rel span',
					duration: 400,
					delay: (t,i) => i*40,
					easing: 'easeInOutExpo',
					opacity: [0,1],
					translateY: ['-100%', '0%']
				})
			}
			function textHide() {
				anime({
					targets: '.slick-slide .word-rel span',
					opacity: 0
				})
			}
			function svg() {
				anime({
					targets: '.slick-current .shapes > *',
					duration: 400,
					delay: (t,i) => i*20,
					easing: 'easeOutBack',
					translateX: {
						value: () => [anime.random(-100,100),anime.random(-10,10)],
						easing: 'easeOutExpo',
					},
					translateY: () => [anime.random(-100,0),anime.random(-400,-50)],
					scale: () => {
						const rand = randomBetween(0.2,0.5);
						return [rand,rand];
					},
					rotate: () => anime.random(-15,15),
					opacity: [
						{
							value: 1, 
							duration:1, 
							delay: (t,i) => i*20
						}, 
						{
							value:0,
							duration: 500, 
							easing: 'linear'
						}
					]
				});
			}
			

			jQuery('.slick-arrow').on('click', function() {
				textHide();
			});


			$videos.on('init', function(event, slick){
				var currentSlide = jQuery(this).find('.slick-slide.slick-current');

				if(currentSlide) {
					textAnime2();
				}
			});

			$videos.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				// responsive: [
				//   {
				// 	breakpoint: 815,
				// 	settings: {
				// 		arrows: false
				// 	}
				//   }
				// ]
			});

            // $videos.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //   $videos.addClass('is-sliding');
            // });
      
            $videos.on('afterChange', function(event, slick, currentSlide){
              $videos.addClass('slided');
			  svg();
				textAnime2();
            });
			function textAnime2() {
				anime({
					targets: '.slick-current .word-vid span',
					duration: 400,
					delay: (t,i) => i*40,
					easing: 'easeInOutExpo',
					opacity: [0,1],
					translateY: ['-100%', '0%']
				})
			}

			jQuery('.article-video .button').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = jQuery(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = jQuery(this).parents('.type-video');
					
				if (!document.querySelector('.media-youtube-video')) {
					$parent.addClass('playing');
					$parent.append(embedCode);
					jQuery('.js-video-list').addClass('has-embed');
				} else {
					$parent.removeClass('playing');
					jQuery('.media-youtube-video').remove();
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});
			jQuery('.js-video-list > button').on('click', function(){
				if (jQuery('.article-video').hasClass('playing')) {
					jQuery('.media-youtube-video').remove();
					jQuery('.article-video').removeClass('playing');
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});

			jQuery('.js-intro-arrow').on('click', function(e){
				e.preventDefault();

				jQuery('html, body').animate({
					scrollTop: jQuery('.section-about').offset().top - 64
				}, 500);
			});

			jQuery('.main-home .section').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {

						if( self.hasClass('section-music') ) {
							textAnime();
						}

						if( self.hasClass('section-videos') ) {
							textAnime2();
						}

						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('show');
					}, offset: '50%'
				});
			});

			if( $win.width() < 480) {

				var waypoints = jQuery('.section-about').waypoint({
					handler: function(direction) {
					  if(direction == 'up') {
						jQuery('#top-bar-menu .logo').removeClass('show');
					  } else {
						jQuery('#top-bar-menu .logo').addClass('show');
					  }
					}, offset: '0'
				  });
			}
		}

		// wrap span on word break
		// jQuery(window).resize(function() {
		// 	letterStack();
		// });

		// letterStack();

		// function letterStack() {
		// 	jQuery('.banner-item').each(function(index){
		// 		var btWt = jQuery(this).find('.content'),
		// 			bTitle = jQuery(this).find('h2');
	
		// 		var spanInserted = bTitle.html().split(" ").join(" </span><span>");
		// 		var wrapped = ("<span>").concat(spanInserted, "</span>");
		// 		bTitle.html(wrapped);
		// 		var refPos = jQuery(this).find('span:first-child').position().top;
		// 		var newPos;
	
		// 		jQuery(this).find('span').each(function(index) {
		// 			newPos = jQuery(this).position().top   
		// 			if (index == 0){
		// 			   return;
		// 			}
		// 			if (newPos == refPos){
		// 				jQuery(this).prepend(jQuery(this).prev().text() + " ");
		// 				jQuery(this).prev().remove();
		// 			} 
		// 			refPos = newPos;
		// 		});
		// 	});
		// }
	});
}); 